import { render, staticRenderFns } from "./spoilt_stock.vue?vue&type=template&id=6aa9e639&"
import script from "./spoilt_stock.vue?vue&type=script&lang=js&"
export * from "./spoilt_stock.vue?vue&type=script&lang=js&"
import style0 from "./spoilt_stock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports